import { Typography } from "@mui/material";

import CheckboxGroup from "@/components/CheckboxGroup";

import { useFilterContext } from "../FilterContext";

const FilterItemDates = () => {
  const { filterData, setFilterData, filterOptions, filterOptionsCount, datePriceMap } =
    useFilterContext();

  return (
    <CheckboxGroup
      options={filterOptions.datesOptions.map((item) => ({
        ...item,
        label: (
          <div className="my-[5px]">
            <Typography>
              {`${item.label} (${filterOptionsCount["dates"][item.value]?.progress}/${
                filterOptionsCount["dates"][item.value]?.total
              })`.replaceAll("undefined", "0")}
            </Typography>
            <div className="flex">
              <Typography>
                {Number(datePriceMap?.get(item.value)?.awardPoints ?? 0).toLocaleString()} pts + ${datePriceMap?.get(item.value)?.tax ?? 0}
              </Typography>
            </div>
          </div>
        ),
      }))}
      value={
        filterData.date.length > 0
          ? filterData.date
          : filterOptions.datesOptions.map(({ value }) => value)
      }
      onChange={(value) => {
        setFilterData({
          date: value.length === filterOptions.datesOptions.length ? [] : value,
        });
      }}
    />
  );
};

export default FilterItemDates;
